import React from 'react';
import { Handle, Position } from 'reactflow';
import { Webhook } from 'lucide-react';

const WebhookNode = ({ data }) => {
  return (
    <div className="bg-orange-100 border-2 border-orange-400 rounded-lg p-4 min-w-[200px]">
      <div className="flex items-center gap-2 mb-2">
        <Webhook size={20} className="text-orange-600" />
        <div className="font-semibold text-orange-900">Webhook</div>
      </div>
      <div className="text-sm text-orange-700">
        {data.label || 'Fetch Data'}
      </div>
      {data.webhookUrl && (
        <div className="text-xs text-orange-600 mt-1 truncate">
          {data.webhookUrl.substring(0, 30)}...
        </div>
      )}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-4 !h-4 !bg-orange-500 !border-2 !border-white"
        style={{ top: -8 }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-4 !h-4 !bg-orange-500 !border-2 !border-white"
        style={{ bottom: -8 }}
      />
    </div>
  );
};

export default WebhookNode;

